<template>
    <v-card width="500" flat>
        <v-card-title class="mb-6">
            <v-row no-gutters justify="center">
                <img src="@/assets/images/kloner_logo_black.svg" width="260" alt="" class="mr-4" />
            </v-row>
        </v-card-title>

        <v-card-text>
            <v-row v-if="token.loading">
                <v-col cols="12" align="center" class="py-12">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>

            <v-row v-else-if="token.validated && !token.valid">
                <v-col cols="12" align="center">
                    <div class="headline">Invalid user invite token.</div>
                </v-col>
            </v-row>

            <user-invite-register-form v-else :token="this.$route.params.token"></user-invite-register-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserInviteRegisterForm from '@/components/auth/UserInviteRegisterForm'

export default {
    name: 'Register',
    components: {
        UserInviteRegisterForm
    },
    computed: {
        ...mapState('register', ['token', 'userInvite'])
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('register', ['validateInviteToken'])
    },
    created() {
        if (this.isLoggedIn) {
            this.logout()
                .then(() => {
                    this.validateInviteToken(this.$route.params.token)
                })
        } else {
            this.validateInviteToken(this.$route.params.token)
        }   
    }
}
</script>